import React from "react";
import "./Header.css";

function Header() {
  return (
    <header className="helios-header">
      <div className="helios-header-content">
        <a href="#/" className="helios-logo-link">
          <span className="home-icon"></span>
        </a>
      </div>
    </header>
  );
}

export default Header;